export const getFetchEntries = (filter?: (entry: PerformanceResourceTiming) => boolean) =>
  new Promise<PerformanceResourceTiming[]>((resolve) => {
    const observer = new PerformanceObserver((list) => {
      const entries = [...list.getEntries()] as PerformanceResourceTiming[]

      resolve(filter ? entries.filter(filter) : entries)
    })

    observer.observe({ type: "resource", buffered: true })
  })

export const getFetchEntriesMeasurements = async (
  filter?: (entry: PerformanceResourceTiming) => boolean,
) => {
  const entries = await getFetchEntries(filter)

  return entries.map((entry) => ({
    name: `fetch:${new URL(entry.name).pathname}`,
    startTime: toSeconds(entry.startTime, performance.timeOrigin),
    duration: toSeconds(entry.duration),
    detail: entry.deliveryType ? { deliveryType: entry.deliveryType } : undefined,

    // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming#typical_resource_timing_metrics
    children: [
      {
        name: "domainLookup",
        startTime: toSeconds(entry.domainLookupStart, performance.timeOrigin),
        duration: toSeconds(entry.domainLookupEnd - entry.domainLookupStart),
      },
      {
        name: "connect",
        startTime: toSeconds(entry.connectStart, performance.timeOrigin),
        duration: toSeconds(entry.connectEnd - entry.connectStart),
      },
      {
        name: "request",
        startTime: toSeconds(entry.requestStart, performance.timeOrigin),
        duration: toSeconds(entry.responseStart - entry.requestStart),
      },
      {
        name: "response",
        startTime: toSeconds(entry.responseStart, performance.timeOrigin),
        duration: toSeconds(entry.responseEnd - entry.responseStart),
      },
    ],
  }))
}

const toSeconds = (ms: number, base = 0) => (base + ms) / 1000

declare global {
  interface PerformanceResourceTiming {
    // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/deliveryType
    deliveryType?: string
  }
}
